export default "__VITE_ASSET__D_2g62Bq__"